import { Seccion, Spinner } from 'asocomponents'
import React, { useEffect, useState } from 'react'
import JuicioServices from '../../../../modules/Juicio/application/JuicioServices'
import { WEBURLEGALES } from '../../../helpers/frontend'
import { formatearFechaLuxon } from '../../../../modules/utils/formatearFecha'

export default function InstruccionesJuicio({ cargaHabilitada, idJuicio }) {

    const [isLoading, setIsLoading] = useState(false)
    const [resultado, setResultado] = useState([])
    const [existenRdos, setExistenRdos] = useState(true)
    //PARA EL PAGINADO
    const [paginaActual, setPaginaActual] = useState(1)
    const [elementosPorPagina] = useState(10) // Cambia esto según cuántos elementos quieres mostrar por página

    const [message, setMessage] = useState("")

    //#region paginado y fetchData
    const indiceUltimoElemento = paginaActual * elementosPorPagina
    const indicePrimerElemento = indiceUltimoElemento - elementosPorPagina
    let totalPaginas = resultado === null ? 1 : Math.ceil(resultado.length / elementosPorPagina)

    const elementosPaginados =
        resultado === null
            ? []
            : resultado.slice(indicePrimerElemento, indiceUltimoElemento)

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina)
    }

    const obtenerInstruccionesJuicio = async () => {
        setIsLoading(true)
        const juicioService = new JuicioServices()
        const result = await juicioService.getInstruccionesJuicioByIdReingenieria(idJuicio) //226905

        result.length > 0 ? setExistenRdos(true) : setExistenRdos(false)

        setPaginaActual(1)
        setResultado(result)

        setIsLoading(false)
    }

    useEffect(() => {
        if (idJuicio && idJuicio !== -1)
            obtenerInstruccionesJuicio()
    }, [idJuicio])


    if (isLoading) {
        return <Spinner color="red" size="50" />
    }

    return (
        <div>
            {cargaHabilitada &&
                <>
                    <Seccion titulo="INSTRUCCIONES" />
                    <div className="overflow-hidden flex flex-col items-center">
                        <div className="shadow-md sm:rounded-lg w-[95%]">
                            <table className="table-fixed text-xs text-left rtl:text-right text-gray-500 w-full">
                                <thead className="text-[0.6rem] text-gray-700 uppercase bg-gray-200">
                                    <tr>
                                        <th scope="col" className="text-center  py-3" style={{ width: "10%" }}>
                                            Fecha
                                        </th>
                                        <th scope="col" className="text-center  py-3" style={{ width: "90%" }}>
                                            Instrucción
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {elementosPaginados &&
                                        elementosPaginados.map((inst, index) => (
                                            <tr
                                                className="bg-white border-b hover:bg-gray-50 text-xs font-normal"
                                                key={inst.id}
                                            >
                                                <td className="text-center py-2">{formatearFechaLuxon(inst.fecha, "dd-MM-yyyy")}</td>

                                                <td className="text-center py-2">{inst.instruccion}</td>

                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                        {existenRdos &&
                            <div className="w-full flex justify-end items-center mr-12 mt-2">
                                <span className="text-sm m-1">
                                    Página {paginaActual} de {totalPaginas === 0 ? 1 : totalPaginas}
                                </span>
                                <button
                                    className="bg-white hover:bg-gray-200 hover:text-white text-black p-1 rounded border-solid border-[1px] border-gray-400 w-8"
                                    onClick={() => cambiarPagina(paginaActual - 1)}
                                    disabled={paginaActual === 1}
                                >
                                    {"<"}
                                </button>
                                <button
                                    className="bg-white hover:bg-gray-200 hover:text-white text-black p-1 rounded border-solid border-[1px] border-gray-400 w-8"
                                    onClick={() => cambiarPagina(paginaActual + 1)}
                                    disabled={resultado ? indiceUltimoElemento >= resultado.length : true}
                                >
                                    {">"}
                                </button>
                            </div>
                         }
                    </div>
                </>
            }
        </div>
    )
}